import { ArrowUpRight } from 'lucide-react'
import Badge from '../../components/badge'
import BannerProjects from '../../components/bannerProjects'
import CardServicos from '../../components/cardServicos'
import CardsVerticais from '../../components/cardsVerticais'
import Rodape from '../../components/rodape'
import SquadBeneficios from '../../components/squadBeneficios'
import FormularioRD from '../../rdstation/formularioRD'
import { useModal } from '../../contexts/ModalContext'

export default function Monitoramento() {
  const { openModal } = useModal();
  const mock = [
    {
      label: 'Backup',
    },
    {
      label: 'Banco de dados',
    },
    {
      label: 'Aplicações',
    },
    {
      label: 'Custos',
    },
    {
      label: 'Network',
    },
    {
      label: 'Suporte',
    },
    {
      label: 'Workland',
    },
    {
      label: 'Segurança',
    },
  ]
  const expertiseSections = [
    {
      title: 'Análise Automatizada',
      content: 'Algoritmos identificam padrões e anomalias.',
    },
    {
      title: 'Coleta em Tempo Real',
      content: 'Agregação de dados de performance, logs e eventos.',
    },
    {
      title: 'Alertas Imediatos',
      content: 'Notificações em tempo real para problemas críticos.',
    },
  ]
  const cards = [
    {
      icon: '../assets/icones/monitoramento/experiencia.svg',
      title: 'Experiência do usuário',
      text: 'Garanta consistência, eficiência e qualidade.',
      glowColor: '#FC0021',
    },
    {
      icon: '../assets/icones/monitoramento/escala.svg',
      title: 'Escalabilidade',
      text: ' Faça ajustes em tempo real para atender às mudanças na demanda.',
      glowColor: '#FC0021',
    },
    {
      icon: '../assets/icones/monitoramento/reducao.svg',
      title: 'Redução de custos',
      text: 'Evite desperdícios e gastos desnecessários.',
      glowColor: '#FC0021',
    },
  ]
  const beneficios = [
    {
      icon: '../assets/icones/monitoramento/deteccao.svg',
      title: 'Detecção precoce',
      text: 'Identifique e neutralize ameaças, evitando danos e prejuízos ao seu negócio.',
      glowColor: '#FC0021',
    },
    {
      icon: '../assets/icones/monitoramento/conformidade.svg',
      title: 'Conformidade',
      text: 'Aplique medidas de segurança em tempo real para minimizar e mitigar riscos.',
      glowColor: '#FC0021',
    },
    {
      icon: '../assets/icones/monitoramento/reducao.svg',
      title: 'Redução de custos',
      text: 'Aplique medidas de segurança em tempo real para minimizar e mitigar riscos.',
      glowColor: '#FC0021',
    },
  ]

  return (
    <>
      <BannerProjects
        backgroundImage="../assets/cover-seguranca.png"
        title={
          <>
            /Monitoramento <br />
            <strong className="font-inter-regular">contínuo</strong>
          </>
        }
        iconSrc="../assets/icone-projectiva-nex2ai.png"
        iconAlt="Projectiva Nex2AI"
        iconText="omni"
        iconTextBold="core"
        descriptionBold=""
        description={
          <>
            <strong className="font-inter-bold">
              Gestão descomplicada da sua infraestrutura em nuvem
            </strong>{' '}
            com monitoramento proativo, gerenciamento inteligente de recursos,
            otimização de custos e suporte especializado, para que você foque no
            crescimento do seu negócio.
          </>
        }
        footerText="VERTICAL INNOVATION | Cloud"
        buttonText="Quero me conectar"
        buttonColor="from-[#FC0021] via-[#FC0021] to-[#5534D9]"
        brand="nex2ai"
      />
      <section className="bg-[rgba(4,1,22,1)]">
        <div className="pt-20 pb-9 container mx-auto px-20">
          <div className="flex flex-wrap justify-center gap-2">
            {mock.map((item, index) => (
              <Badge key={index} className="min-w-fit">{item.label}</Badge>
            ))}
          </div>
        </div>
      </section>
      <SquadBeneficios
        title={
          <p className="text-5xl font-inter-light">
            Monitore e proteja sua nuvem em tempo real com{' '}
            <span className="bg-gradient-to-r from-[rgba(252,0,33,1)] via-[rgba(145,12,206,1)] to-[rgba(85,52,217,1)] bg-clip-text text-transparent relative">
              máxima eficiência
            </span>
          </p>
        }
        cards={[
          {
            icon: '../assets/icones/monitoramento/monitoramento.svg',
            title: 'Monitoramento proativo',
            text: 'Antecipamos problemas e geramos soluções com agilidade.',
            glowColor: '#FC00218C',
          },
          {
            icon: '../assets/icones/monitoramento/gerenciamento.svg',
            title: 'Gerenciamento de recursos:',
            text: 'Ajustamos sua infraestrutura para garantir eficiência e evitar desperdícios.',
            glowColor: '#FC00218C',
          },
          {
            icon: '../assets/icones/monitoramento/otimizacao.svg',
            title: 'Otimização de custos',
            text: 'Analisamos seu uso de recursos para maximizar a economia.',
            glowColor: '#FC00218C',
          },
          {
            icon: '../assets/icones/monitoramento/suporte.svg',
            title: 'Suporte especializado',
            text: 'Proporcionamos suporte contínuo para alinhar a infraestrutura aos objetivos do seu negócio.',
            glowColor: '#FC00218C',
          },
          {
            icon: '../assets/icones/monitoramento/foco.svg',
            title: 'Foco no seu negócio',
            text: 'Simplificamos a gestão da nuvem, permitindo que você se concentre no que realmente importa.',
            glowColor: '#FC00218C',
          },
        ]}
      />
      <section className="bg-[url(../assets/banner-next2a.png)] bg-cover text-white">
        <div className="container mx-auto xl:max-w-6xl py-32 grid grid-cols-2 items-center gap-24">
          <div className="space-y-6">
            <h3 className="font-inter-light text-4xl">
              <strong className="font-inter-bold">
                Com o monitoramento contínuo, tenha análises de dados em tempo
                real na nuvem,{" "}
              </strong>
              identificando problemas para impulsionar melhorias e otimizações
              constantes.
            </h3>
            <button
              onClick={() => openModal(<FormularioRD />)}
              className="bg-white font-bold py-3 px-8 rounded-full shadow-md hover:scale-105 transition-transform duration-300 cursor-pointer"
              style={{
                background: 'white',
                backgroundClip: 'padding-box',
              }}
            >
              <span className="text-[rgba(252,0,33,1)]">
                Otimize seus negócios
              </span>
            </button>
          </div>
          <CardsVerticais initialSections={expertiseSections} />
        </div>
      </section>
      <section className="text-white bg-[rgba(19,20,24,1)] relative overflow-hidden">
        <div className="container mx-auto xl:max-w-6xl py-32 space-y-28">
          <header className="text-center drop-shadow-[0_5px_5px_rgb(19,20,24)]">
            <h2 className="text-6xl drop-shadow-lg">Principais benefícios</h2>
          </header>
          <main className="relative z-10 flex gap-8 px-14 backdrop-blur-xl bg-gray-400/10 rounded-[10px] border border-white w-fit">
            <div className="text-center flex flex-col items-center py-14">
              <h3 className="text-2xl font-medium mb-4">Resolução Ágil:</h3>
              <p className="text-gray-300 max-w-xs">
                Identificação e correção rápida de falhas.
              </p>
            </div>

            <div className="h-[90px] w-px bg-[#C4C4C4] my-auto" />

            <div className="text-center flex flex-col items-center py-14">
              <h3 className="text-2xl font-medium mb-4">Melhoria Contínua:</h3>
              <p className="text-gray-300 max-w-xs">
                Feedback constante para otimizações.
              </p>
            </div>

            <div className="h-[90px] w-px bg-[#C4C4C4] my-auto" />

            <div className="text-center flex flex-col items-center py-14">
              <h3 className="text-2xl font-medium mb-4">
                Segurança Fortalecida:
              </h3>
              <p className="text-gray-300 max-w-xs">
                Detecção precoce de ameaças e vulnerabilidades.
              </p>
            </div>
          </main>
        </div>
        <img
          src="../assets/cover-maxima-seguranca.png"
          alt=""
          className="absolute left-0 bottom-0 w-full"
        />
      </section>
      <section className="bg-[rgba(4,1,22,1)] pt-[140px] pb-[79px] text-white">
        <div className="container mx-auto xl:max-w-6xl flex flex-col md:flex-row items-center gap-[60px] px-6">
          <div className="md:w-1/2">
            <h2 className="text-4xl font-inter-light mb-2">
              Monitoramento de{' '}
              <span className="bg-gradient-to-r from-[rgba(252,0,33,1)] via-[rgba(145,12,206,1)] to-[rgba(85,52,217,1)] bg-clip-text text-transparent font-inter-medium">
                Performance e<br />
                Disponibilidade
              </span>
            </h2>
          </div>
          <div className="md:w-1/2">
            <p className="text-lg">
              Ao monitorar a performance e disponibilidade da sua infraestrutura
              e aplicações na nuvem, garanta operações de alta performance,
              mesmo em indicadores críticos, como tempo de resposta, uso de CPU,
              memória e latência.
            </p>
          </div>
        </div>
      </section>
      <section>
        <div className="w-full bg-[rgba(4,1,22,1)] py-24 relative overflow-hidden">
          <div className="max-w-[1200px] mx-auto relative z-10 px-4">
            <>
              <h3 className="font-inter-light text-[40px] mb-14 text-center text-white">
                Por que é importante:
              </h3>

              {/* All 3 cards in one row */}
              <div className="grid grid-cols-3 gap-6">
                {cards.map((card, index) => (
                  <div key={index}>
                    <CardServicos
                      icon={card.icon}
                      iconHover={card.iconHover || card.icon}
                      title={card.title}
                      text={card.text}
                      glowColor={card.glowColor || '#A002CB'}
                      url={card.url}
                    />
                  </div>
                ))}
              </div>
            </>

            <div className="flex items-center gap-8 bg-[rgba(42,13,93,1)] px-6 py-3.5 rounded-[10px] text-white w-[350px] mt-3.5">
              <h3 className="w-fit font-inter-light">
                Otimize seu <br /> negócio!
              </h3>
              <button
                onClick={() => openModal(<FormularioRD />)}
                className="w-fit bg-[rgba(252,0,33,1)] text-white text-sm font-inter-light flex items-center m-auto gap-2 py-2 px-10 rounded-full cursor-pointer hover:scale-105 transition-all duration-300"
              >
                Contratar <ArrowUpRight className="size-5" />
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-[url(../assets/cover-proposito.png)] bg-no-repeat bg-cover">
        <article className="pt-[140px] pb-[79px] text-white">
          <div className="container mx-auto xl:max-w-6xl flex flex-col md:flex-row items-center gap-[60px] px-6">
            <div className="md:w-1/2">
              <h2 className="text-4xl font-inter-light mb-2">
                Monitoramento <br /> de{' '}
                <span className="bg-gradient-to-r from-[rgba(252,0,33,1)] via-[rgba(145,12,206,1)] to-[rgba(85,52,217,1)] bg-clip-text text-transparent font-inter-medium">
                  Segurança
                </span>
              </h2>
            </div>
            <div className="md:w-1/2">
              <p className="text-lg">
                Identifique atividades suspeitas e vulnerabilidades
                instantaneamente, garantindo a proteção dos dados e das suas
                aplicações.
              </p>
            </div>
          </div>
        </article>
        <article>
          <div className="w-full py-24 relative overflow-hidden">
            <div className="max-w-[1200px] mx-auto relative z-10 px-4">
              <>
                <h3 className="font-inter-light text-[40px] mb-14 text-center text-white">
                  Benefícios:
                </h3>

                {/* All 3 cards in one row */}
                <div className="grid grid-cols-3 gap-6">
                  {beneficios.map((card, index) => (
                    <div key={index}>
                      <CardServicos
                        icon={card.icon}
                        iconHover={card.iconHover || card.icon}
                        title={card.title}
                        text={card.text}
                        glowColor={card.glowColor || '#A002CB'}
                        url={card.url}
                      />
                    </div>
                  ))}
                </div>
              </>

              <div className="flex items-center gap-8 bg-[rgba(42,13,93,1)] px-6 py-3.5 rounded-[10px] text-white w-[350px] mt-3.5">
                <h3 className="w-fit font-inter-light">
                  Otimize seu <br /> negócio!
                </h3>
                <button
                  onClick={() => openModal(<FormularioRD />)}
                  className="w-fit bg-[rgba(252,0,33,1)] text-white text-sm font-inter-light flex items-center m-auto gap-2 py-2 px-10 rounded-full cursor-pointer hover:scale-105 transition-all duration-300"
                >
                  Contratar <ArrowUpRight className="size-5" />
                </button>
              </div>
            </div>
          </div>
        </article>
      </section>
      <section className="bg-[url(../assets/cloud-red.png)] bg-cover bg-no-repeat text-white">
        <div className="container mx-auto xl:max-w-6xl py-20 text-center space-y-12">
          <p className="text-[40px] font-inter-light">
            <strong className="font-inter-bold">
              Segurança aprimorada e controle em tempo real <br />
            </strong>{' '}
            para antecipar problemas e resoluções ágeis com total eficiência.
          </p>

          <div className="hover:scale-105 transition-transform duration-300">
            <button
              onClick={() => openModal(<FormularioRD />)}
              className="bg-white rounded-full text-[rgba(252,0,33,1)] py-2 px-7 text-2xl font-inter-light cursor-pointer"
            >
              Otimize seu negócio
            </button>
          </div>
        </div>
      </section>
      <Rodape />
    </>
  )
}
